var render = function () {
  var _ref, _ref3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }, {
      name: "justify",
      rawName: "v-justify",
      value: {
        content: 'stretch'
      },
      expression: "{ content: 'stretch' }"
    }]
  }, [_c('base-button', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }, {
      name: "align",
      rawName: "v-align",
      value: {
        items: 'center'
      },
      expression: "{ items: 'center' }"
    }, {
      name: "justify",
      rawName: "v-justify",
      value: {
        content: 'center'
      },
      expression: "{ content: 'center' }"
    }, {
      name: "m-r",
      rawName: "v-m-r",
      value: 10,
      expression: "10"
    }, {
      name: "border-radius",
      rawName: "v-border-radius",
      value: '50px',
      expression: "'50px'"
    }],
    class: [_vm.$style.button, _vm.$style.project, (_ref = {}, _ref[_vm.$style.active] = _vm.isActiveRoute('projects') || _vm.isActiveRoute('partners'), _ref)],
    staticStyle: {
      "width": "40px",
      "height": "40px"
    },
    attrs: {
      "disabled": _vm.isMenuVisibility
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('navigate');
      }
    }
  }, [_c('base-icon', {
    attrs: {
      "name": "basic_menu-button"
    }
  })], 1), _vm.isShownProjectList ? [_vm._l(_vm.projects, function (project) {
    var _ref2;

    return _c('base-button', {
      directives: [{
        name: "m-r",
        rawName: "v-m-r",
        value: 10,
        expression: "10"
      }],
      key: project.id,
      class: [_vm.$style.project, (_ref2 = {}, _ref2[_vm.$style.active] = _vm.isActiveProject(project), _ref2)],
      attrs: {
        "disabled": _vm.isMenuVisibility
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('change-project', project);
        }
      }
    }, [_c('project-logo', {
      directives: [{
        name: "background-color",
        rawName: "v-background-color:dark-blue-3",
        arg: "dark-blue-3"
      }],
      attrs: {
        "project": project
      }
    })], 1);
  }), _c('base-button', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }, {
      name: "align",
      rawName: "v-align",
      value: {
        items: 'center'
      },
      expression: "{ items: 'center' }"
    }, {
      name: "justify",
      rawName: "v-justify",
      value: {
        content: 'center'
      },
      expression: "{ content: 'center' }"
    }, {
      name: "border-radius",
      rawName: "v-border-radius",
      value: '50px',
      expression: "'50px'"
    }],
    class: _vm.$style.button,
    staticStyle: {
      "width": "40px",
      "height": "40px"
    },
    attrs: {
      "disabled": _vm.isMenuVisibility
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('create-project');
      }
    }
  }, [_c('base-icon', {
    attrs: {
      "size": 16,
      "name": "basic_plus"
    }
  })], 1)] : _vm._e()], 2), _c('div', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }, {
      name: "justify",
      rawName: "v-justify",
      value: {
        content: 'stretch'
      },
      expression: "{ content: 'stretch' }"
    }]
  }, [_vm.useSelfEmployed ? _c('base-button', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }, {
      name: "align",
      rawName: "v-align",
      value: {
        items: 'center'
      },
      expression: "{ items: 'center' }"
    }, {
      name: "justify",
      rawName: "v-justify",
      value: {
        content: 'center'
      },
      expression: "{ content: 'center' }"
    }, {
      name: "relative",
      rawName: "v-relative"
    }, {
      name: "border-radius",
      rawName: "v-border-radius",
      value: '50px',
      expression: "'50px'"
    }, {
      name: "m-r",
      rawName: "v-m-r",
      value: 10,
      expression: "10"
    }],
    class: [_vm.$style.button, (_ref3 = {}, _ref3[_vm.$style.active] = _vm.isActiveRoute('notifications'), _ref3[_vm.$style.tooltip] = true, _ref3)],
    staticStyle: {
      "width": "40px",
      "height": "40px"
    },
    attrs: {
      "disabled": _vm.isMenuVisibility,
      "data-title": _vm.$t('header.menu.notifications')
    },
    on: {
      "click": function click($event) {
        _vm.$router.push({
          name: 'notifications'
        }).catch(function () {});
      }
    }
  }, [_c('base-icon', {
    attrs: {
      "name": "notifications_bell"
    }
  }), _vm.notificationsCount > 0 ? _c('base-badge', {
    directives: [{
      name: "absolute",
      rawName: "v-absolute"
    }, {
      name: "top",
      rawName: "v-top",
      value: 0,
      expression: "0"
    }, {
      name: "right",
      rawName: "v-right",
      value: 0,
      expression: "0"
    }],
    attrs: {
      "count": _vm.notificationsCount
    }
  }) : _vm._e()], 1) : _vm._e(), _c('header-menu-list', {
    attrs: {
      "menu-list": _vm.menuList,
      "shown-text": false,
      "horizontal-menu": "",
      "shown-tooltip": ""
    },
    on: {
      "logout": function logout($event) {
        return _vm.$emit('logout');
      }
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }